import styles from './FileIcon.module.scss'
import { ReactComponent as gz } from './gz.svg'
import { ReactComponent as pdf } from './pdf.svg'
import { ReactComponent as rtf } from './rtf.svg'
import { ReactComponent as txt } from './txt.svg'
import { ReactComponent as vcard } from './vcard.svg'
import { ReactComponent as vcf } from './vcf.svg'
import { ReactComponent as video } from './video.svg'
import { ReactComponent as zip } from './zip.svg'

const icons = {
  gz,
  pdf,
  rtf,
  txt,
  vcard,
  vcf,
  zip,
  avi: video,
  mp4: video,
  m4v: video,
  mpg: video,
  mpeg: video,
  m1v: video,
  mpv: video,
  ogv: video,
  ogx: video,
  ogg: video,
  spx: video,
  ogm: video,
  mov: video,
  qt: video,
  webm: video,
  wmv: video,
  '3gp': video
}

const FileIcon = ({ extension }) => {
  const Icon = icons[extension]

  return (
    <div className={styles.container}>
      <Icon />
    </div>
  )
}

export default FileIcon
